<template>
  <Modal v-if="open">
    <Card
      class="give-all-confirm p-6 flex flex-col"
      style="box-shadow: 0px 1px 4px rgba(46, 41, 78, 0.02), 0px 8px 12px rgba(46, 41, 78, 0.08)"
    >
      <div class="flex items-start justify-between">
        <p class="text-lg font-bold text-darkPurple">Give all access</p>
        <button
          type="button"
          class="give-all-confirm__close"
          aria-label="Close"
          @click="$emit('cancel')"
        >
          <Icon icon-name="close-icon" size="xs" class-name="text-romanSilver" />
        </button>
      </div>
      <div class="border-t border-romanSilver my-4" />
      <div class="flex flex-col items-center text-center">
        <Icon icon-name="icon-warning" size="l" class-name="text-flame mb-4" />
        <p class="text-sm text-jet leading-relaxed">
          This will grant this role access to every app and privilege available
          in Humanar. You can still adjust individual privileges before saving.
        </p>
      </div>
      <div class="flex w-full gap-2 mt-4">
        <Button
          class="bg-dynamicBackBtn text-white confirm-btn h-10 w-full  rounded-lg"
          @click="$emit('confirm')"
        >
          Yes
        </Button>
        <Button
          background-color="none"
          class="text-dynamicBackBtn border border-solid border-dynamicBackBtn confirm-btn w-full rounded-lg"
          @click="$emit('cancel')"
        >
          Cancel
        </Button>
      </div>
    </Card>
  </Modal>
</template>

<script>
import Card from "@/components/Card";
import Modal from "@/components/Modal";

export default {
  name: "GiveAllAccessConfirm",
  components: {
    Card,
    Modal,
  },
  props: {
    open: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style scoped>
.give-all-confirm {
  width: 100%;
  max-width: 28rem;
  border-radius: 0.75rem;
}

.give-all-confirm__close {
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  background: transparent;
  border: none;
  padding: 0;
}
</style>
